import { ExcludeCitiesOptions } from '../../elements/excluded/FlyExcludedCities'
import { logAndReject } from '../../utils/promise'
import { Theme } from '../models/funnelOrder/theme'
import { getSiteCountryICC2, SiteCountry } from '../models/locale'
import { getClient } from '../openapi'

export function getThemeCities(
  theme: Theme,
  country: SiteCountry,
): Promise<ExcludeCitiesOptions[]> {
  return getClient()
    .then(client =>
      client.apis.bookings.bookings_theme_cities({
        theme,
        site_country: getSiteCountryICC2(country),
      }),
    )
    .then(response => response.body)
    .then(cities =>
      cities.map((x: any) => ({
        value: x.id,
        label: x.name,
        direction: x.direction,
      })),
    )
    .catch(logAndReject)
}
